import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Your presence, cheer, and friendship are the best gifts but if you wish to also send a gift, we prepared a list of suggestions. Feel free to click on the link provided below. Thank you!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      